var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "rule-configuration-dialog",
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("CargoMsg.Cargo_Appoint2"),
        "before-close": _vm.cancel,
        width: "650px",
        "append-to-body": ""
      }
    },
    [
      _c(
        "div",
        { staticStyle: { display: "flex", margin: "10px" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { "margin-left": "450px" },
              attrs: { type: "danger" },
              on: {
                click: function($event) {
                  return _vm.onDel(null)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Menu.delete")))]
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%", "min-height": "340px" },
            attrs: {
              "column-defs": _vm.columnDefs,
              "grid-options": _vm.gridOptions,
              "row-data": _vm.rowData,
              "show-side-bar": false
            },
            on: { rowDataChanged: _vm.rowDataChanged }
          })
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          [
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.onSave } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
            ),
            _c("el-button", { on: { click: _vm.cancel } }, [
              _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
            ])
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }